import { PagedList } from '@deltager/organizers/admin/shared/models/paged-list.model';
import { BookingReportCalendarItem } from '../booking-report-calendar/booking-report-calendar.models';
import {
  BookingReportCalendarFilter,
  BookingReportTableFilter,
  BookingReportViewType,
  CalendarViewType,
} from '../booking-report-filters/booking-report-filters.models';
import { BookingReportTableItem } from '../booking-report-table/booking-report-table.models';

export interface BookingReportState {
  calendarFilters?: BookingReportCalendarFilter;
  tableFilters?: BookingReportTableFilter;
  calendarItems: BookingReportCalendarItem[];
  tableItems: PagedList<BookingReportTableItem>;
  view: BookingReportViewType;
  calendarViewType?: CalendarViewType;
}

export const INITIAL_BOOKING_REPORT_STATE: BookingReportState = {
  calendarFilters: null,
  tableFilters: null,
  calendarItems: [],
  tableItems: { total: 0, items: [] } as PagedList<BookingReportTableItem>,
  view: BookingReportViewType.Calendar,
  calendarViewType: CalendarViewType.Day,
};
